import { render, staticRenderFns } from "./projectView.vue?vue&type=template&id=d5e0dcb2&scoped=true"
import script from "./projectView.vue?vue&type=script&lang=js"
export * from "./projectView.vue?vue&type=script&lang=js"
import style0 from "./projectView.vue?vue&type=style&index=0&id=d5e0dcb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e0dcb2",
  null
  
)

export default component.exports